export const COMPANY_COPY = {
  title: 'Use your company website so we can create a custom agent for you',
  description:
    'We\’ll automatically gather public information from your site (FAQs, help pages and contact details) and use it to build an agent tailored to your business. No need to paste multiple links, one URL is enough.',
  websiteLabel: 'Company website',
  websitePlaceholder: 'https://www.example.com',
  cta: 'Create agent',
  loadingMessages: [
    'Learning about your company',
    'Analyzing your website',
    'Scanning your product and pricing pages',
    'Reviewing your About and Contact info',
    'Picking up your tone and phrasing',
    'Mapping common questions from your site',
    'Setting up your agent profile',
    'Drafting your welcome message',
    'Preparing example replies in your style',
    'Customizing your experience',
    'Generating voice options',
  ],
  fallbackMessage: 'Preparing your agent...',
} as const;
